<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index;">
        <ng-container *ngIf="roleIncluded(item)">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        </ng-container>
    </ng-container>
</ul>   
